import React, {useState, useEffect} from 'react';
import {useTranslation} from '@deviceinsight/ng-ui-scale-lib/api';
import {Link} from 'react-router-dom';
import {PaginationSettings, ReactableRowDef, Reactable, ContentHeader} from '@deviceinsight/ng-ui-components';
import {AssetGroup, Pageable} from '@deviceinsight/ng-ui-api-client';
import {SpinnerContainer} from '@deviceinsight/ng-ui-basic-components';
import {UpdateJob} from './types';
import './types';
import {JOB_STATUS, CREATE_JOB} from './consts';
import jobColumnDefs from './columnDefs/jobColumnDefs';
import {fetchJobs, fetchPendingOrActiveJobs} from '../../api/updateJobsApi';
import './AdminList.less';
import hasAuthority from '../common/hasAuthority';
type Props = {
	assetGroup: AssetGroup;
};

const HEADER_TITLE = {
	id: 'updatejobs.list.title',
	defaultValue: 'Update Jobs'
};
const INITIAL_PAGINATION_SETTINGS: PaginationSettings = {
	page: 0,
	size: 15,
	sort: {
		property: 'createdAt',
		direction: 'DESC'
	}
};
const rowDef: ReactableRowDef<UpdateJob> = {
	getRowClass: (job) => (job.status === JOB_STATUS.PENDING || job.status === JOB_STATUS.ACTIVE ? 'highlighted' : '')
};

const AdminList = ({assetGroup}: Props) => {
	const {t} = useTranslation();
	const [hasActiveOrPending, setHasActiveOrPending] = useState<boolean>(false);
	const [jobs, setJobs] = useState<Pageable<UpdateJob> | null | undefined>();
	const [loading, setLoading] = useState<boolean>(false);
	const [paginationSettings, setPaginationSettings] = useState<PaginationSettings>(INITIAL_PAGINATION_SETTINGS);
	const canCreateJob = hasAuthority(CREATE_JOB);
	const assetGroupId = assetGroup.id;
	useEffect(() => {
		setLoading(true);
		fetchJobs(assetGroup.id?.toString(), paginationSettings).then((data) => {
			setJobs(data);
			setLoading(false);
		});
		fetchPendingOrActiveJobs(assetGroup.id?.toString()).then((data) =>
			setHasActiveOrPending(data.totalElements > 0)
		);
	}, [assetGroup, paginationSettings]);

	const createJobTitle = t('updatejobs.list.create', {
		defaultValue: 'Create update job'
	});

	return (
		<div className="admin-list">
			<ContentHeader title={HEADER_TITLE}>
				{!hasActiveOrPending && canCreateJob && (
					<div className="di header-toolbar">
						<Link
							className="tool add"
							to={`/assetgroups/${assetGroupId}/updatejobs/create`}
							title={createJobTitle}
						/>
					</div>
				)}
			</ContentHeader>
			<SpinnerContainer show={loading}>
				<div
					className="bundle-version-table"
					style={{
						minHeight: 50
					}}>
					<Reactable
						isLoading={false}
						uniqueItemKey={(version) => version.id}
						columnDefs={jobColumnDefs(assetGroup.id?.toString())}
						paginationSettings={paginationSettings}
						onChangePage={(page) => setPaginationSettings({...paginationSettings, page})}
						onSort={(property, direction) =>
							setPaginationSettings({
								...paginationSettings,
								sort: {
									property,
									direction
								}
							})
						}
						pageable={jobs}
						rowDef={rowDef}
					/>
				</div>
			</SpinnerContainer>
		</div>
	);
};

export default AdminList;
